import React, { Component, Fragment, SyntheticEvent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { History } from 'history'

import { fetchRefiTransaction } from './refiTransactionsActions'
import { selectRefiTransaction } from '../../reducers'
import { RefiTransaction } from './types'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Loader from '../../components/loader'

import { addRefiProduct } from '../refiApp/refiActions'
import RefiProductForm from '../../components/refiProductForm'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  fetchRefiTransaction: Callback<Promise<any>>
  addRefiProduct: Callback<Promise<any>>
  refiTransaction: RefiTransaction
  match: Match<ParamsID>
  history: History
}

export class refiTransactionsAddProduct extends Component<Props> {
  static displayName = 'refiTransactionsAddProduct'

  state = {
    isLoading: false,
    newProductPrice: null,
  }

  componentWillMount() {
    this.fetchRefi()
  }

  onPriceChange = (evt: SyntheticEvent) => {
    const element = evt.currentTarget as HTMLInputElement
    this.setState({ newProductPrice: element.value })
  }

  fetchRefi = () => {
    const { fetchRefiTransaction, match } = this.props
    fetchRefiTransaction(match.params && match.params.id)
  }

  onSubmit = () => {
    const { match, history, addRefiProduct } = this.props

    const toSubmit = {
      id: Number(match.params.id),
      retailPrice: Number(this.state.newProductPrice),
    }

    this.setState({ isLoading: true })

    return addRefiProduct(toSubmit)
      .then(() => {
        history.push({ pathname: `/refinance/${match.params.id}` })
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  backToIndex = () => {
    this.props.history.goBack()
  }

  render() {
    const { isLoading } = this.state

    return (
      <Fragment>
        <TransitionGroup>
          {isLoading && (
            <CSSTransition
              classNames="slow-fade"
              timeout={{
                enter: 200,
                exit: 500,
              }}
            >
              <div className="loading-overlay">
                <Loader isLoading={true} className="loading-overlay__loader" />
                <p className="loading-overlay__text">
                  Please wait... It will take a minute.
                </p>
              </div>
            </CSSTransition>
          )}
        </TransitionGroup>
        <RefiProductForm
          onSubmit={this.onSubmit}
          cancel={this.backToIndex}
          onPriceChange={this.onPriceChange}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = (state, { match }) => {
  return {
    refiTransaction: selectRefiTransaction(
      state.refiTransactions,
      match.params.id
    ),
  }
}

const mapDispatchToProps = (dispatch) => ({
  addRefiProduct: (params) => dispatch(addRefiProduct(params)),
  fetchRefiTransaction: (id) => dispatch(fetchRefiTransaction(id)),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(refiTransactionsAddProduct)
)
